// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Float from "rescript/lib/es6/belt_Float.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ReactAlert from "react-alert";
import * as Belt_SetString from "rescript/lib/es6/belt_SetString.js";
import * as Core from "@material-ui/core";
import * as App_Modal$DvmAdminFrontendFr from "../../../../../../common/components/App_Modal.bs.js";
import * as App_Button$DvmAdminFrontendFr from "../../../../../../common/components/button/App_Button.bs.js";
import * as SimpleAlert$DvmAdminFrontendFr from "../../../../../../alert/SimpleAlert.bs.js";
import * as Utils_Alert$DvmAdminFrontendFr from "../../../../../../common/utils/Utils_Alert.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../../../context/user/User_Context.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../../../../../common/App_Typography.bs.js";
import * as Messages_Button$DvmAdminFrontendFr from "../../../../../../intl/messages/Messages_Button.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../../../../common/types/App_Types_Result.bs.js";
import * as Flash_Detail_Api$DvmAdminFrontendFr from "../../../../../flash/detail/Flash_Detail_Api.bs.js";
import * as App_OverlaySpinner$DvmAdminFrontendFr from "../../../../../../common/components/App_OverlaySpinner.bs.js";
import * as Messages_Orders_DealerRequest$DvmAdminFrontendFr from "../../../../../../intl/messages/orders/Messages_Orders_DealerRequest.bs.js";
import * as Order_Detail_Bonus_Derogate_Order_Info$DvmAdminFrontendFr from "../../derogate/create/Order_Detail_Bonus_Derogate_Order_Info.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Inputs$DvmAdminFrontendFr from "./Order_Detail_Bonus_DealerRequest_Inputs.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Confirm$DvmAdminFrontendFr from "../confirm/Order_Detail_Bonus_DealerRequest_Confirm.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Refused$DvmAdminFrontendFr from "../confirm/Order_Detail_Bonus_DealerRequest_Refused.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Create_Api$DvmAdminFrontendFr from "./Order_Detail_Bonus_DealerRequest_Create_Api.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Action_Info$DvmAdminFrontendFr from "./Order_Detail_Bonus_DealerRequest_Action_Info.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Create_Form$DvmAdminFrontendFr from "./Order_Detail_Bonus_DealerRequest_Create_Form.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Create_Types$DvmAdminFrontendFr from "./Order_Detail_Bonus_DealerRequest_Create_Types.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Document_Uploader$DvmAdminFrontendFr from "./Order_Detail_Bonus_DealerRequest_Document_Uploader.bs.js";

function Order_Detail_Bonus_DealerRequest_Create(Props) {
  var order = Props.order;
  var orderId = Props.orderId;
  var action = Props.action;
  var onClose = Props.onClose;
  var onOk = Props.onOk;
  var orderType = Props.orderType;
  var savedDocuments = Props.savedDocuments;
  var reloadPage = Props.reloadPage;
  var origBonus = Props.origBonus;
  var existingRequests = Props.existingRequests;
  var intl = ReactIntl.useIntl();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var alert = ReactAlert.useAlert();
  var match$2 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setActionIdOptions = match$2[1];
  var match$3 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setSaveResult = match$3[1];
  var saveResult = match$3[0];
  var match$4 = React.useState(function () {
        return /* NotStarted */0;
      });
  var match$5 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setDocumentTypes = match$5[1];
  var match$6 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setFetchedFlash = match$6[1];
  var fetchedFlash = match$6[0];
  var match$7 = React.useState(function () {
        return null;
      });
  var setModal = match$7[1];
  var match$8 = React.useState(function () {
        return false;
      });
  var match$9 = React.useState(function () {
        return false;
      });
  var setDocNameIssue = match$9[1];
  var docNameIssue = match$9[0];
  var match$10 = React.useState(function () {
        return /* [] */0;
      });
  var setNewDocuments = match$10[1];
  var newDocuments = match$10[0];
  var match$11 = React.useState(function () {
        return savedDocuments;
      });
  var setExistingDocuments = match$11[1];
  var existingDocuments = match$11[0];
  var form = Order_Detail_Bonus_DealerRequest_Create_Form$DvmAdminFrontendFr.Form.useForm(action !== undefined ? ({
            actionId: action.actionId,
            amount: Belt_Option.mapWithDefault(action.amount, "", (function (prim) {
                    return String(prim);
                  })),
            requestType: orderType === /* SO */0 ? "PERF" : "",
            comment: Belt_Option.getWithDefault(action.comment, ""),
            actionLabel: Belt_Option.mapWithDefault(origBonus, "", (function (x) {
                    return Belt_Option.getWithDefault(x.actionLabel, "");
                  }))
          }) : (
          orderType === /* SO */0 ? ({
                actionId: Order_Detail_Bonus_DealerRequest_Create_Form$DvmAdminFrontendFr.initialState.actionId,
                amount: Order_Detail_Bonus_DealerRequest_Create_Form$DvmAdminFrontendFr.initialState.amount,
                requestType: "PERF",
                comment: Order_Detail_Bonus_DealerRequest_Create_Form$DvmAdminFrontendFr.initialState.comment,
                actionLabel: Order_Detail_Bonus_DealerRequest_Create_Form$DvmAdminFrontendFr.initialState.actionLabel
              }) : Order_Detail_Bonus_DealerRequest_Create_Form$DvmAdminFrontendFr.initialState
        ), (function (output, submissionCallbacks) {
          Order_Detail_Bonus_DealerRequest_Create_Api$DvmAdminFrontendFr.saveOrEditRequest(userManager, setSaveResult, orderId, submissionCallbacks, selectedRole, Belt_Option.isSome(action) ? /* Edit */0 : /* Create */1, output);
        }));
  React.useEffect((function () {
          Belt_Option.mapWithDefault(action, undefined, (function (action) {
                  if (orderType === /* CL */1) {
                    return Flash_Detail_Api$DvmAdminFrontendFr.fetchFlash(action.actionId, userManager, setFetchedFlash, selectedRole, /* NonFleet */1);
                  }
                  
                }));
        }), []);
  React.useEffect((function () {
          Belt_Option.mapWithDefault(action, undefined, (function (param) {
                  if (typeof fetchedFlash === "number" || !(fetchedFlash.TAG === /* Ok */0 && orderType === /* CL */1)) {
                    return ;
                  } else {
                    return Curry._2(form.updateRequestType, (function (input, requestType) {
                                  return {
                                          actionId: input.actionId,
                                          amount: input.amount,
                                          requestType: requestType,
                                          comment: input.comment,
                                          actionLabel: input.actionLabel
                                        };
                                }), Belt_Option.getWithDefault(fetchedFlash._0.requestType, ""));
                  }
                }));
        }), [fetchedFlash]);
  React.useEffect((function () {
          if (form.input.requestType.length > 0 || orderType === /* SO */0) {
            Order_Detail_Bonus_DealerRequest_Create_Api$DvmAdminFrontendFr.fetchActionSelect(alert, userManager, setActionIdOptions, selectedRole, orderType === /* SO */0 ? "PERF" : form.input.requestType, orderId);
          }
          
        }), [form.input.requestType]);
  var confirmClose = function (param) {
    Utils_Alert$DvmAdminFrontendFr.success(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {}));
    Curry._1(onOk, undefined);
  };
  React.useEffect((function () {
          if (typeof saveResult === "number") {
            saveResult === /* NotStarted */0;
          } else if (saveResult.TAG === /* Ok */0) {
            if (Belt_List.length(newDocuments) === 0) {
              confirmClose(undefined);
            }
            
          } else {
            Utils_Alert$DvmAdminFrontendFr.error(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {
                      message: {
                        TAG: /* RestError */2,
                        _0: saveResult._0
                      }
                    }));
          }
        }), [
        saveResult,
        newDocuments
      ]);
  React.useEffect((function () {
          if (form.input.requestType.length > 0 && orderType !== /* SO */0) {
            Order_Detail_Bonus_DealerRequest_Create_Api$DvmAdminFrontendFr.fetchDocumentTypes(userManager, setDocumentTypes, selectedRole, form.input.requestType);
          }
          
        }), [form.input.requestType]);
  React.useEffect((function () {
          var allDocs = Belt_List.concat(Belt_List.map(existingDocuments, (function (x) {
                      return Belt_Option.getWithDefault(x.fileName, "");
                    })), Belt_List.map(newDocuments, (function (x) {
                      return x.document.name;
                    })));
          var distinctDocs = Belt_SetString.toList(Belt_SetString.fromArray(Belt_List.toArray(allDocs)));
          Curry._1(setDocNameIssue, (function (param) {
                  return Belt_List.length(allDocs) !== Belt_List.length(distinctDocs);
                }));
        }), [
        existingDocuments,
        newDocuments
      ]);
  return React.createElement(App_Modal$DvmAdminFrontendFr.make, {
              open: true,
              onClose: (function (param) {
                  Curry._1(onClose, undefined);
                  if (Belt_List.length(existingDocuments) !== Belt_List.length(savedDocuments)) {
                    return Curry._1(reloadPage, undefined);
                  }
                  
                }),
              title: intl.formatMessage(Messages_Orders_DealerRequest$DvmAdminFrontendFr.dealerRequestTitle, {
                    id: order.header.orderCustomerOrderNumber
                  }),
              minWidth: "1200px",
              children: null
            }, React.createElement(App_OverlaySpinner$DvmAdminFrontendFr.make, {
                  show: App_Types_Result$DvmAdminFrontendFr.isPending(saveResult) || App_Types_Result$DvmAdminFrontendFr.isPending(fetchedFlash) || match$8[0],
                  children: null
                }, React.createElement(Order_Detail_Bonus_DealerRequest_Document_Uploader$DvmAdminFrontendFr.make, {
                      setUploadPending: match$8[1],
                      newDocuments: newDocuments,
                      setNewDocuments: setNewDocuments,
                      saveResult: saveResult,
                      orderId: orderId,
                      actionId: form.input.actionId,
                      setExistingDocuments: setExistingDocuments
                    }), React.createElement("form", {
                      onKeyDown: (function ($$event) {
                          if ($$event.key !== "Enter") {
                            return ;
                          } else {
                            $$event.preventDefault();
                            return ;
                          }
                        }),
                      onSubmit: (function ($$event) {
                          $$event.preventDefault();
                          Curry._1(setModal, (function (param) {
                                  if (Belt_Option.getWithDefault(Belt_Float.fromString(form.input.amount), 0.0) >= Order_Detail_Bonus_DealerRequest_Create_Types$DvmAdminFrontendFr.maxAmount) {
                                    return React.createElement(Order_Detail_Bonus_DealerRequest_Refused$DvmAdminFrontendFr.make, {
                                                amount: Order_Detail_Bonus_DealerRequest_Create_Types$DvmAdminFrontendFr.maxAmount,
                                                onClose: (function (param) {
                                                    Curry._1(setModal, (function (param) {
                                                            return null;
                                                          }));
                                                  })
                                              });
                                  } else {
                                    return React.createElement(Order_Detail_Bonus_DealerRequest_Confirm$DvmAdminFrontendFr.make, {
                                                amount: Belt_Option.getWithDefault(Belt_Float.fromString(form.input.amount), 0.0),
                                                onClose: (function (param) {
                                                    Curry._1(setModal, (function (param) {
                                                            return null;
                                                          }));
                                                  }),
                                                onOk: (function (param) {
                                                    Curry._1(setModal, (function (param) {
                                                            return null;
                                                          }));
                                                    Curry._1(form.submit, undefined);
                                                  }),
                                                modification: Belt_Option.isSome(action)
                                              });
                                  }
                                }));
                        })
                    }, React.createElement(Core.Box, {
                          children: null,
                          marginX: 1
                        }, React.createElement(Core.Grid, {
                              children: null,
                              container: true,
                              direction: "column",
                              spacing: 3
                            }, React.createElement(Order_Detail_Bonus_Derogate_Order_Info$DvmAdminFrontendFr.make, {
                                  order: order
                                }), React.createElement(Order_Detail_Bonus_DealerRequest_Action_Info$DvmAdminFrontendFr.make, {
                                  orderType: orderType,
                                  actionId: form.input.actionId,
                                  actionFetch: match$4[0],
                                  setActionFetch: match$4[1],
                                  form: form
                                })), React.createElement(Order_Detail_Bonus_DealerRequest_Inputs$DvmAdminFrontendFr.make, {
                              action: action,
                              form: form,
                              actionIdOptions: match$2[0],
                              order: order,
                              newDocuments: newDocuments,
                              setNewDocuments: setNewDocuments,
                              orderId: orderId,
                              existingDocuments: existingDocuments,
                              setExistingDocuments: setExistingDocuments,
                              documentTypes: match$5[0],
                              existingRequests: existingRequests
                            }), React.createElement(Core.Box, {
                              children: React.createElement(Core.Grid, {
                                    alignItems: "flex-end",
                                    children: null,
                                    container: true,
                                    direction: "column"
                                  }, docNameIssue ? React.createElement(Core.Grid, {
                                          children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                                color: "error",
                                                gutterBottom: true,
                                                children: intl.formatMessage(Messages_Orders_DealerRequest$DvmAdminFrontendFr.sameDocumentsWarning),
                                                variant: "subtitle"
                                              }),
                                          item: true
                                        }) : null, React.createElement(Core.Grid, {
                                        children: React.createElement(App_Button$DvmAdminFrontendFr.make, {
                                              label: intl.formatMessage(Messages_Button$DvmAdminFrontendFr.confirm),
                                              size: "medium",
                                              disabled: docNameIssue,
                                              type_: "submit"
                                            }),
                                        item: true
                                      })),
                              mt: 2
                            })))), match$7[0]);
}

var Form;

var Api;

var Types;

var make = Order_Detail_Bonus_DealerRequest_Create;

export {
  Form ,
  Api ,
  Types ,
  make ,
}
/* react Not a pure module */
